import PropTypes from 'prop-types';
import { Button } from '@skyline-platform/alchemy';
// Shared with StreamStepperFlow and BulkActions — keep in sync with ../helpers.js
import { handleEnterKeyDown } from '../helpers';

import './FormFooter.css';

/**
 * Standard Cancel + Submit button pair used in fullscreen forms.
 *
 * Pass this as the `footer` prop of <Form>:
 *   footer={[<FormFooter key='footer' ... />]}
 */
export const FormFooter = ({
  onCancel,
  onSubmit,
  submitLabel,
  isValid,
  cancelLabel = 'Cancel',
}) => (
  <gar-form-footer>
    <Button
      label={cancelLabel}
      type='outlined'
      onClick={onCancel}
      onKeyDown={(event) => handleEnterKeyDown(event, onCancel)}
    />
    <Button
      label={submitLabel}
      type='filled'
      onClick={onSubmit}
      onKeyDown={(event) => handleEnterKeyDown(event, onSubmit)}
      state={isValid ? 'default' : 'disabled'}
    />
  </gar-form-footer>
);

FormFooter.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitLabel: PropTypes.string.isRequired,
  isValid: PropTypes.bool.isRequired,
  cancelLabel: PropTypes.string,
};
